import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import PageWrapper from '../PageWrapper'
//import { Document, Page, pdfjs } from "react-pdf";

import { connect } from 'react-redux'
import PdfModal from './PdfModal'

import { API_BASE_URL } from '../../config'
import { Tooltip } from 'antd';
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import Message from '../AlertComponent/Message'
import ProfileUpdate from '../AlertComponent/ProfileUpdate'


// import routes from '../Routes';
function Profile(props) {
  //


  const [state, setState] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstname: '',
    lastname: '',
    phone: '', qualification: '', selectedFile: "", category: '', error: { message: '', name: '' }, gender: '', skill: [], experience: '', loader: false, successeres: '', success: false, image: '', old_image: '', old_resume: '', resume: ''
  })
  const [modalShow, setModalShow] = useState(false);
  const [successmessage, setsuccessmessage] = useState(false);
  const [update, setupdate] = useState(false)

  const login = props.login
  useEffect(() => {
    const login = props.login
    //pdfjs.GlobalWorkerOptions.workerSrc ="//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js";

    if (props.userData === "") {
      setState((prev) => ({ ...prev, loader: true }))
      var data = new FormData();
      data.append("action", "get_all_user")
      data.append("u_id", login.user_id)


      const requestOptions = {
        method: 'post',
        body: data
      };
      fetch(API_BASE_URL + 'data_process.php', requestOptions)
        .then((response) => response.json())
        .then(async (responseJson) => {

          if (responseJson.success === "true") {
            await props.userinfo(responseJson.data[0])
            var userinfo = responseJson.data[0]
            const skill = userinfo.u_skill.split(',');

            await setState((prev) => ({ ...prev, email: userinfo.u_email, phone: userinfo.u_phone, firstname: userinfo.u_fname, lastname: userinfo.u_lname, password: userinfo.u_pwd, confirmPassword: userinfo.u_pwd, qualification: userinfo.u_qualification, category: userinfo.u_category, skill: skill, experience: userinfo.u_experience, gender: userinfo.u_gender, old_image: userinfo.u_image, old_resume: userinfo.u_resume_url, loader: false }))


          }

        })
        .catch((error) => {

        });
    } else {
      //setState((prev)=>({...prev,email:props.userData.u_email,phone:props.userData.u_email,firstname:props.userData.u_fname}))
      var userinfo = props.userData
      const skill = userinfo.u_skill.split(',');
      setState((prev) => ({ ...prev, email: userinfo.u_email, phone: userinfo.u_phone, firstname: userinfo.u_fname, lastname: userinfo.u_lname, password: userinfo.u_pwd, confirmPassword: userinfo.u_pwd, qualification: userinfo.u_qualification, category: userinfo.u_category, skill: skill, experience: userinfo.u_experience, gender: userinfo.u_gender, old_image: userinfo.u_image, old_resume: userinfo.u_resume_url }))
    }
  }, [])





  const onImageChange = async (event) => {
    var file = event.target.files[0];
    var old_state = state
    old_state.image = file
    await setState(old_state);
    sendDetailsToServer()

  }

  const onFileChange = async (event) => {
    setState(prevState => ({
      ...prevState,
      error: { message: '', name: "" }
    }))
    var file = await event.target.files[0]
    //var file = event.target.files[0]
    if (file) {
      var old_state = state
      old_state.selectedFile = file
      await setState(old_state);

      sendDetailsToServer()
    }


  };
  const sendDetailsToServer = async () => {
    //first_name
    setState((prev) => ({
      ...prev, loader: true, successeres: ""
    }))
    var data = new FormData();
    await data.append("action", "user_profile_update");
    await data.append("first_name", state.firstname);
    await data.append("last_name", state.lastname);
    await data.append("email", state.email);
    await data.append("contact", state.phone);
    await data.append("gender", state.gender === "Female" ? 2 : 1);
    await data.append("qualification", state.qualification);
    await data.append("experience", state.experience);
    await data.append("category", state.category);
    await data.append("skill", state.skill);
    await data.append("resume", state.selectedFile);
    await data.append("password", state.password);
    await data.append("user_image", state.image);
    await data.append("u_id", login.user_id);

    const requestOptions = {
      method: 'post',
      body: data
    };
    fetch(API_BASE_URL + 'data_process.php', requestOptions)
      .then((response) => response.json())
      .then((responseJson) => {


        setState((prev) => ({
          ...prev, loader: false, successeres: responseJson
        }))
        setsuccessmessage(true)

      })
      .catch((error) => {

      });
  }
  return (
    <PageWrapper  title={"profile"}>
      <div class="profileUpdate">
          <PdfModal
                              show={modalShow}
                              onHide={() =>{document.body.classList.remove("showModal");setModalShow(false)}}
                              url={state.selectedFile === "" ? state.old_resume : URL.createObjectURL(state.selectedFile)}
                              cross={state.selectedFile === "" ? true : false}
   />
           <Message show={successmessage} handleClose={() => setsuccessmessage(false)} message={state.successeres}></Message>
           {state.loader && <div className="overly">
                      <div className={"loaderdiv"}>
                        <div class="spinner-border text-danger" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </div>}
      <>
        <div className="Toastify" />
        <div className="inner_pages_box w-left">
          <ProfileUpdate show={update} handleClose={() => setupdate(false)} data={state} updatessuccess={async (data) => {
console.log(data,"data")
            var userinfo = await props.userData;
            userinfo.u_fname = await data.firstname;
            userinfo.u_lname = await data.lastname;
            userinfo.u_email = await data.email
            userinfo.u_pwd = await data.password;
            userinfo.u_qualification = await data.qualification;
            userinfo.u_category = await data.category;
            userinfo.u_experience = await data.experience;
            userinfo.u_gender = await data.gender;
            userinfo.u_phone = await data.phone;
            userinfo.u_skill = await ((data.skill).toString());
            await props.userinfo(userinfo);
            var login = props.login
            login.user_fname = data.firstname
            await props.loginupdate(login)
            await localStorage.setItem('login', JSON.stringify(login));
            //var userinfo=
            await setState((prev) => ({ ...prev, email: userinfo.u_email, phone: userinfo.u_phone, firstname: userinfo.u_fname, lastname: userinfo.u_lname, password: userinfo.u_pwd, confirmPassword: userinfo.u_pwd, qualification: userinfo.u_qualification, category: userinfo.u_category, experience: userinfo.u_experience, gender: userinfo.u_gender, old_image: userinfo.u_image, old_resume: userinfo.u_resume_url, skill: data.skill }))
            setupdate(false)

          }}></ProfileUpdate>
          <div className="inner_pages mb">
            <div className="container">
              <div className="mdc-title">
                <h3>Profile Update<span>Profile Update</span></h3>
              </div>
            </div>
            <div className="container">
              <div className="form_wrapper width_100">
             
                <div className="form_container">
                  <div className="row">
                  
                    <div className="candidate_left mgbt-xs-20 ">
                      <div className="form-group">
                        <div className="candidate_width">
                          <div className="form-img text-center">
                            <div className="candi_img">

                              {(state.image === "" && state.old_image === "") ? <img src={require("../../images/image_placeholder.png")} style={{ width: "100%" }} alt={"User"} /> : state.image !== "" ? <img src={URL.createObjectURL(state.image)} style={{ width: "100%" }} alt={"User"} /> : <img src={(state.old_image)} style={{ width: "100%" }} alt={"User"} />}
                            </div>
                            <label className="uploadimage">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 419.2 419.2"><path d="M394.4,250.4c-13.6-12.8-30.8-21.2-49.6-23.6V80.4c0-15.6-6.4-29.6-16.4-40C318,30,304,24,288.4,24h-232
                                      c-15.6,0-29.6,6.4-40,16.4C6,50.8,0,64.8,0,80.4v184.4V282v37.2c0,15.6,6.4,29.6,16.4,40c10.4,10.4,24.4,16.4,40,16.4h224.4
                                      c14.8,12,33.2,19.6,53.6,19.6c23.6,0,44.8-9.6,60-24.8c15.2-15.2,24.8-36.4,24.8-60C419.2,286.8,409.6,265.6,394.4,250.4z
                                      M21.2,80.4c0-9.6,4-18.4,10.4-24.4c6.4-6.4,15.2-10.4,24.8-10.4h232c9.6,0,18.4,4,24.8,10.4c6.4,6.4,10.4,15.2,10.4,24.8v124.8
                                      l-59.2-59.2c-4-4-10.8-4.4-15.2,0L160,236l-60.4-60.8c-4-4-10.8-4.4-15.2,0l-63.2,64V80.4z M56,355.2v-0.8
                                      c-9.6,0-18.4-4-24.8-10.4c-6-6.4-10-15.2-10-24.8V282v-12.4L92,198.4l60.4,60.4c4,4,10.8,4,15.2,0l89.2-89.6l58.4,58.8
                                      c-1.2,0.4-2.4,0.8-3.6,1.2c-1.6,0.4-3.2,0.8-5.2,1.6c-1.6,0.4-3.2,1.2-4.8,1.6c-1.2,0.4-2,0.8-3.2,1.6c-1.6,0.8-2.8,1.2-4,2
                                      c-2,1.2-4,2.4-6,3.6c-1.2,0.8-2,1.2-3.2,2c-0.8,0.4-1.2,0.8-2,1.2c-3.6,2.4-6.8,5.2-9.6,8.4c-15.2,15.2-24.8,36.4-24.8,60
                                      c0,6,0.8,11.6,2,17.6c0.4,1.6,0.8,2.8,1.2,4.4c1.2,4,2.4,8,4,12v0.4c1.6,3.2,3.2,6.8,5.2,9.6H56z M378.8,355.2
                                      c-11.6,11.6-27.2,18.4-44.8,18.4c-16.8,0-32.4-6.8-43.6-17.6c-1.6-1.6-3.2-3.6-4.8-5.2c-1.2-1.2-2.4-2.8-3.6-4
                                      c-1.6-2-2.8-4.4-4-6.8c-0.8-1.6-1.6-2.8-2.4-4.4c-0.8-2-1.6-4.4-2-6.8c-0.4-1.6-1.2-3.6-1.6-5.2c-0.8-4-1.2-8.4-1.2-12.8
                                      c0-17.6,7.2-33.2,18.4-44.8c11.2-11.6,27.2-18.4,44.8-18.4s33.2,7.2,44.8,18.4c11.6,11.6,18.4,27.2,18.4,44.8
                                      C397.2,328,390,343.6,378.8,355.2z" />
                                <path d="M341.6,267.6c-0.8-0.8-2-1.6-3.6-2.4c-1.2-0.4-2.4-0.8-3.6-0.8c-0.4,0-0.4,0-0.4,0c-0.4,0-0.4,0-0.4,0
                                      c-1.2,0-2.4,0.4-3.6,0.8c-1.2,0.4-2.4,1.2-3.6,2.4l-24.8,24.8c-4,4-4,10.8,0,15.2c4,4,10.8,4,15.2,0l6.4-6.4v44
                                      c0,6,4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8v-44l6.4,6.4c4,4,10.8,4,15.2,0c4-4,4-10.8,0-15.2L341.6,267.6z" />
                              </svg>
                              <input type="file" accept="image/x-png,image/gif,image/jpeg" style={{"display": "none"}} onChange={onImageChange}/>
                              </label></div>
                          <br />
                          <div className="Example__container__document">
                      
                          <Tooltip placement="top" title={"View Resume"}>
                                        <span><p><img src={require("../../images/pdf.png")} alt={""} /><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 419.2 419.2" onClick={() => {document.body.classList.add("showModal"); setModalShow(true)}}><path d="M394.4,250.4c-13.6-12.8-30.8-21.2-49.6-23.6V80.4c0-15.6-6.4-29.6-16.4-40C318,30,304,24,288.4,24h-232
                                      c-15.6,0-29.6,6.4-40,16.4C6,50.8,0,64.8,0,80.4v184.4V282v37.2c0,15.6,6.4,29.6,16.4,40c10.4,10.4,24.4,16.4,40,16.4h224.4
                                      c14.8,12,33.2,19.6,53.6,19.6c23.6,0,44.8-9.6,60-24.8c15.2-15.2,24.8-36.4,24.8-60C419.2,286.8,409.6,265.6,394.4,250.4z
                                      M21.2,80.4c0-9.6,4-18.4,10.4-24.4c6.4-6.4,15.2-10.4,24.8-10.4h232c9.6,0,18.4,4,24.8,10.4c6.4,6.4,10.4,15.2,10.4,24.8v124.8
                                      l-59.2-59.2c-4-4-10.8-4.4-15.2,0L160,236l-60.4-60.8c-4-4-10.8-4.4-15.2,0l-63.2,64V80.4z M56,355.2v-0.8
                                      c-9.6,0-18.4-4-24.8-10.4c-6-6.4-10-15.2-10-24.8V282v-12.4L92,198.4l60.4,60.4c4,4,10.8,4,15.2,0l89.2-89.6l58.4,58.8
                                      c-1.2,0.4-2.4,0.8-3.6,1.2c-1.6,0.4-3.2,0.8-5.2,1.6c-1.6,0.4-3.2,1.2-4.8,1.6c-1.2,0.4-2,0.8-3.2,1.6c-1.6,0.8-2.8,1.2-4,2
                                      c-2,1.2-4,2.4-6,3.6c-1.2,0.8-2,1.2-3.2,2c-0.8,0.4-1.2,0.8-2,1.2c-3.6,2.4-6.8,5.2-9.6,8.4c-15.2,15.2-24.8,36.4-24.8,60
                                      c0,6,0.8,11.6,2,17.6c0.4,1.6,0.8,2.8,1.2,4.4c1.2,4,2.4,8,4,12v0.4c1.6,3.2,3.2,6.8,5.2,9.6H56z M378.8,355.2
                                      c-11.6,11.6-27.2,18.4-44.8,18.4c-16.8,0-32.4-6.8-43.6-17.6c-1.6-1.6-3.2-3.6-4.8-5.2c-1.2-1.2-2.4-2.8-3.6-4
                                      c-1.6-2-2.8-4.4-4-6.8c-0.8-1.6-1.6-2.8-2.4-4.4c-0.8-2-1.6-4.4-2-6.8c-0.4-1.6-1.2-3.6-1.6-5.2c-0.8-4-1.2-8.4-1.2-12.8
                                      c0-17.6,7.2-33.2,18.4-44.8c11.2-11.6,27.2-18.4,44.8-18.4s33.2,7.2,44.8,18.4c11.6,11.6,18.4,27.2,18.4,44.8
                                      C397.2,328,390,343.6,378.8,355.2z" />
                                <path d="M341.6,267.6c-0.8-0.8-2-1.6-3.6-2.4c-1.2-0.4-2.4-0.8-3.6-0.8c-0.4,0-0.4,0-0.4,0c-0.4,0-0.4,0-0.4,0
                                      c-1.2,0-2.4,0.4-3.6,0.8c-1.2,0.4-2.4,1.2-3.6,2.4l-24.8,24.8c-4,4-4,10.8,0,15.2c4,4,10.8,4,15.2,0l6.4-6.4v44
                                      c0,6,4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8v-44l6.4,6.4c4,4,10.8,4,15.2,0c4-4,4-10.8,0-15.2L341.6,267.6z" />
                              </svg></p></span>
                                        </Tooltip>
                           
                              <label className accept="application/pdf">update resume
                            
                              { <input type="file" accept="application/pdf"  style={{"display": "none"}} onChange={onFileChange} />}
                              </label>
                    </div>
                          </div>
                        </div>
                      </div>
                      <div className="candidate_right">
                        <div className="profile_name">
                          <h2>{props.userData.u_fname} {props.userData.u_lname}</h2>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001" onClick={()=>setupdate(true)}>
                            <path d="M496.063,62.299l-46.396-46.4c-21.199-21.199-55.689-21.198-76.888,0C352.82,35.86,47.964,340.739,27.591,361.113
                                      c-2.17,2.17-3.624,5.054-4.142,7.875L0.251,494.268c-0.899,4.857,0.649,9.846,4.142,13.339c3.497,3.497,8.487,5.042,13.338,4.143
                                      L143,488.549c2.895-0.54,5.741-2.008,7.875-4.143l345.188-345.214C517.311,117.944,517.314,83.55,496.063,62.299z M33.721,478.276
                                      l14.033-75.784l61.746,61.75L33.721,478.276z M140.269,452.585L59.41,371.721L354.62,76.488l80.859,80.865L140.269,452.585z
                                       M474.85,117.979l-18.159,18.161l-80.859-80.865l18.159-18.161c9.501-9.502,24.96-9.503,34.463,0l46.396,46.4
                                      C484.375,93.039,484.375,108.453,474.85,117.979z" />
                          </svg>
                        </div>
                        <div className="detail-list mb5">
                          <div className="detail-list-left">
                            <div className="detail-item">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M501.344,106.662H373.342V31.989c0-5.875-4.781-10.656-10.672-10.656H149.338c-5.891,0-10.672,4.781-10.672,10.656v74.673
                                              H10.665C4.773,106.662,0,111.443,0,117.333v170.659c0,5.906,4.773,10.672,10.665,10.672c0,0,3.664,0.828,10.672,2.156v179.176
                                              c0,5.906,4.774,10.672,10.665,10.672H480c5.906,0,10.672-4.766,10.672-10.672V300.82c7.016-1.328,10.672-2.156,10.672-2.156
                                              c5.891,0,10.656-4.766,10.656-10.672V117.333C512,111.443,507.234,106.662,501.344,106.662z M309.341,42.661h42.657v64.001
                                              h-21.329v-32c0-5.891-4.766-10.672-10.672-10.672h-10.656V42.661z M266.668,63.989V42.661h21.329V63.99L266.668,63.989
                                              L266.668,63.989z M309.341,85.333v21.328H202.667V85.333H309.341z M224.004,42.661h21.336v21.328h-21.336V42.661z M160.003,42.661
                                              h42.665V63.99h-10.665c-5.891,0-10.664,4.781-10.664,10.672v32h-21.336V42.661z M469.344,469.339H42.665V304.508
                                              c33.727,5.375,92.774,12.812,170.674,14.922v32.564c0,5.906,4.774,10.672,10.665,10.672h63.993
                                              c5.906,0,10.672-4.766,10.672-10.672V319.43c77.892-2.109,136.955-9.547,170.675-14.922V469.339z M234.668,341.338v-64.002h42.673
                                              v64.002H234.668z M431.89,288.273c-30.625,3.812-76.454,8.234-133.221,9.797v-31.406c0-5.891-4.766-10.672-10.672-10.672h-63.993
                                              c-5.891,0-10.665,4.782-10.665,10.672v31.406c-56.766-1.562-102.595-5.984-133.221-9.797c-29.172-3.656-49.399-7.328-58.782-9.188
                                              V127.99h469.335v151.096h0.001C481.281,280.945,461.062,284.617,431.89,288.273z" />
                                <path d="M256.004,287.992c-5.891,0-10.664,4.781-10.664,10.672v21.328c0,5.906,4.773,10.672,10.664,10.672
                                              c5.891,0,10.664-4.766,10.664-10.672v-21.328C266.668,292.773,261.895,287.992,256.004,287.992z" />
                              </svg><span>{state.experience} Year(s)</span>
                            </div>
                            <div className="detail-item">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M506.103,188.455L260.77,65.788c-3.003-1.501-6.538-1.501-9.54,0L5.897,188.455C2.283,190.262,0,193.956,0,197.995
                                              c0,4.041,2.283,7.734,5.897,9.54l81.215,40.607v81.514c0,50.342,74.185,89.778,168.889,89.778S424.889,380,424.889,329.656
                                              v-81.514l28.346-14.173v77.795c-13.067,4.453-22.494,16.838-22.494,31.393c0,13.196,7.748,24.612,18.932,29.949l-22.659,59.783
                                              c-1.242,3.278-0.795,6.957,1.197,9.841s5.273,4.606,8.778,4.606h53.833c3.505,0,6.786-1.722,8.779-4.606
                                              c1.991-2.884,2.438-6.563,1.197-9.84l-22.659-59.783c11.182-5.337,18.93-16.753,18.93-29.949c0-14.556-9.43-26.942-22.499-31.394
                                              v-88.461l31.536-15.767c3.614-1.807,5.896-5.501,5.896-9.54C512,193.956,509.717,190.262,506.103,188.455z M363.109,376.057
                                              c-28.431,14.215-66.47,22.045-107.109,22.045c-40.639,0-78.677-7.829-107.109-22.045c-25.703-12.852-40.446-29.764-40.446-46.4
                                              V258.81l142.785,71.393c1.502,0.751,3.136,1.126,4.77,1.126s3.268-0.375,4.77-1.126l142.785-71.393v70.847h0
                                              C403.555,346.293,388.813,363.205,363.109,376.057z M452.437,426.005l11.467-30.253l11.466,30.253H452.437z M475.732,343.159
                                              c0.001,6.524-5.306,11.83-11.828,11.83c-6.524,0-11.83-5.307-11.83-11.83c0-6.506,5.279-11.798,11.777-11.827
                                              c0.017,0,0.033,0.002,0.05,0.002c0.018,0,0.035-0.002,0.052-0.002C470.452,331.36,475.732,336.652,475.732,343.159z
                                               M461.736,205.868l-204.78-18.492c-5.867-0.534-11.053,3.797-11.583,9.664c-0.53,5.868,3.797,11.053,9.664,11.583l170.412,15.388
                                              L256,308.737L34.518,197.995L256,87.255l221.482,110.741L461.736,205.868z" />
                              </svg>
                              <span>{props.userData.u_qualification}</span>
                            </div>
                            <div className="detail-item">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M187.628,0H43.707C19.607,0,0,19.607,0,43.707v143.921c0,24.1,19.607,43.707,43.707,43.707h143.921
                                              c24.1,0,43.707-19.607,43.707-43.707V43.707C231.335,19.607,211.728,0,187.628,0z" />
                                <path d="M468.293,0H324.372c-24.1,0-43.707,19.607-43.707,43.707v143.921c0,24.1,19.607,43.707,43.707,43.707h143.921
                                              c24.1,0,43.707-19.607,43.707-43.707V43.707C512,19.607,492.393,0,468.293,0z" />
                                <path d="M187.628,280.665H43.707C19.607,280.665,0,300.272,0,324.372v143.921C0,492.393,19.607,512,43.707,512h143.921
                                              c24.1,0,43.707-19.607,43.707-43.707V324.372C231.335,300.272,211.728,280.665,187.628,280.665z" />
                                <path d="M468.293,280.665H324.372c-24.1,0-43.707,19.607-43.707,43.707v143.921c0,24.1,19.607,43.707,43.707,43.707h143.921
                                              c24.1,0,43.707-19.607,43.707-43.707V324.372C512,300.272,492.393,280.665,468.293,280.665z" />
                              </svg>
                              <span>{props.userData.u_category}</span>
                            </div>
                          </div>
                          <div className="detail-list-right">
                            <div className="detail-item">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M467,61H45C20.218,61,0,81.196,0,106v300c0,24.72,20.128,45,45,45h422c24.72,0,45-20.128,45-45V106
                                              C512,81.28,491.872,61,467,61z M460.786,91L256.954,294.833L51.359,91H460.786z M30,399.788V112.069l144.479,143.24L30,399.788z
                                               M51.213,421l144.57-144.57l50.657,50.222c5.864,5.814,15.327,5.795,21.167-0.046L317,277.213L460.787,421H51.213z M482,399.787
                                              L338.213,256L482,112.212V399.787z" />
                              </svg>
                              <span>{props.userData.u_email}</span>
                            </div>
                            <div className="detail-item">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 482.6 482.6">
                                <path d="M98.339,320.8c47.6,56.9,104.9,101.7,170.3,133.4c24.9,11.8,58.2,25.8,95.3,28.2c2.3,0.1,4.5,0.2,6.8,0.2
                                          c24.9,0,44.9-8.6,61.2-26.3c0.1-0.1,0.3-0.3,0.4-0.5c5.8-7,12.4-13.3,19.3-20c4.7-4.5,9.5-9.2,14.1-14
                                          c21.3-22.2,21.3-50.4-0.2-71.9l-60.1-60.1c-10.2-10.6-22.4-16.2-35.2-16.2c-12.8,0-25.1,5.6-35.6,16.1l-35.8,35.8
                                          c-3.3-1.9-6.7-3.6-9.9-5.2c-4-2-7.7-3.9-11-6c-32.6-20.7-62.2-47.7-90.5-82.4c-14.3-18.1-23.9-33.3-30.6-48.8
                                          c9.4-8.5,18.2-17.4,26.7-26.1c3-3.1,6.1-6.2,9.2-9.3c10.8-10.8,16.6-23.3,16.6-36s-5.7-25.2-16.6-36l-29.8-29.8
                                          c-3.5-3.5-6.8-6.9-10.2-10.4c-6.6-6.8-13.5-13.8-20.3-20.1c-10.3-10.1-22.4-15.4-35.2-15.4c-12.7,0-24.9,5.3-35.6,15.5l-37.4,37.4
                                          c-13.6,13.6-21.3,30.1-22.9,49.2c-1.9,23.9,2.5,49.3,13.9,80C32.739,229.6,59.139,273.7,98.339,320.8z M25.739,104.2
                                          c1.2-13.3,6.3-24.4,15.9-34l37.2-37.2c5.8-5.6,12.2-8.5,18.4-8.5c6.1,0,12.3,2.9,18,8.7c6.7,6.2,13,12.7,19.8,19.6
                                          c3.4,3.5,6.9,7,10.4,10.6l29.8,29.8c6.2,6.2,9.4,12.5,9.4,18.7s-3.2,12.5-9.4,18.7c-3.1,3.1-6.2,6.3-9.3,9.4
                                          c-9.3,9.4-18,18.3-27.6,26.8c-0.2,0.2-0.3,0.3-0.5,0.5c-8.3,8.3-7,16.2-5,22.2c0.1,0.3,0.2,0.5,0.3,0.8
                                          c7.7,18.5,18.4,36.1,35.1,57.1c30,37,61.6,65.7,96.4,87.8c4.3,2.8,8.9,5,13.2,7.2c4,2,7.7,3.9,11,6c0.4,0.2,0.7,0.4,1.1,0.6
                                          c3.3,1.7,6.5,2.5,9.7,2.5c8,0,13.2-5.1,14.9-6.8l37.4-37.4c5.8-5.8,12.1-8.9,18.3-8.9c7.6,0,13.8,4.7,17.7,8.9l60.3,60.2
                                          c12,12,11.9,25-0.3,37.7c-4.2,4.5-8.6,8.8-13.3,13.3c-7,6.8-14.3,13.8-20.9,21.7c-11.5,12.4-25.2,18.2-42.9,18.2
                                          c-1.7,0-3.5-0.1-5.2-0.2c-32.8-2.1-63.3-14.9-86.2-25.8c-62.2-30.1-116.8-72.8-162.1-127c-37.3-44.9-62.4-86.7-79-131.5
                                          C28.039,146.4,24.139,124.3,25.739,104.2z" />
                              </svg>
                              <span>{props.userData.u_phone}</span>
                            </div>
                          </div>
                        </div>
                        <div className="detail-list skills_lists mb5">
                          <div className="skill_width">
                            <div className="detail-item skill_badge">
                              <h2>Add Skills</h2>
                              {  props.userData.u_skill&& 
                                        (props.userData.u_skill.split(',')).map((item)=>(
                                            <span>{item}</span>
                                        ))
                                        }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row" />
                  </div>
                </div>
              </div>
            </div>
          </div>
</>
</div>

      </PageWrapper>
    )
}

//export default Home;
//export default withRouter(Profile);
const mapStateToProps = (state) => {

    return {
        userData: state.list.user,
        login: state.list.login,
        allfeild: state.list.allfeild
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        userinfo: (data) => dispatch({ type: "USER_INFO", payload: data }),
        loginupdate: (data) => dispatch({ type: "LOGIN_INFO", payload: data })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Profile));

